module.exports = __webpack_public_path__ + "img/8.3decddf1.jpg";